<template>
  <b-container fluid>
    <b-row :id="'section-'+post.id">
      <b-col md="6" order="1" :order-md="post.small">
        <div class="stat-wrapper">
          <div class="stat">{{ post.stat }}</div>
          <div class="highlight">{{ post.highlight }}</div>
        </div>
      </b-col>
      <b-col md="4" :offset-md="post.offset" order="2" :order-md="post.large">
        <h2>{{ post.title }}</h2>
        <div v-html="post.description"></div>
        <template v-if="post.graphic === false">
          <div v-html="post.hidden" v-if="seen"></div>
          <b-button v-if="!seen" v-on:click="show()">Learn More</b-button>
        </template>
      </b-col>
    </b-row>
    <template v-if="post.graphic === true">
      <b-row>
        <b-col md="10" offset-md="1" v-html="post.hidden"></b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
export default {
  name: 'post',
  props: ['post'],
  data: function () {
    return {
      seen: false
    }
  },
  methods: {
    show: function () {
      this.seen = !this.seen
    }
  }
}
</script>

<style lang="scss">
  div[id^="section-"] {
    padding: 2em 0 5em;
    &:first-child {
      padding-top: 8em;
      @media all and (max-width: $screen-md) {
        padding-top: 3em;
      }
    }
    h2 {
      position: relative;
      margin: .5em 0;
      @include sans-font(bold);
      font-size: 60px;
      line-height: 55px;
      @media all and (max-width: $screen-md) {
        font-size: 50px;
        line-height: 45px;
      }
      &:before {
        content: "";
        position: absolute;
        background: $black;
        width: 30px;
        height: 10px;
        top: -.5em;
      }
    }
    img {
      opacity: 1;
      left: 0;
      position: relative;
      transition: all ease-in .5s;
      &[src^="data:image"] {
        opacity: 0;
        left: -50px;
      }
    }
    ul {
      text-align: left;
    }
    .offset-md-2 {
      text-align: right;
      h2 {
        &:before {
          left: auto;
          right: 0;
        }
      }
      @media all and (max-width: $screen-md) {
        text-align: left;
        h2 {
          &:before {
            left: 0;
            right: auto;
          }
        }
      }
    }
    button.btn {
      background: none;
      border: 2px solid $blue;
      border-radius: 20px;
      color: $black;
      padding-left: 4em;
      padding-right: 4em;
      transition: background ease-in .3s;
      &:hover,
      &:focus {
        background: $blue;
      }
    }
    .stat-wrapper {
      display: flex;
      justify-content: center;
      align-items: start;
      position: relative;
      z-index: 0;
      @media all and (max-width: $screen-md) {
        padding-bottom: 3em;
      }
      .stat {
        @include sans-font(bold);
        font-size: 65px;
        line-height: 60px;
        text-align: center;
        margin: 1.75em 0;
        @media all and (max-width: $screen-md) {
          margin: 10vw 0;
          font-size: 50px;
          line-height: 45px;
        }
      }
      .highlight {
        @include serif-font();
        font-size: 45vw;
        text-align: center;
        color: $blue;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: -1;
        line-height: .5;
        @media all and (max-width: $screen-md - 1) {
          font-size: 80vw;
        }
      }
    }
  }
  .desktop-img {
    @media all and (max-width: $screen-md - 1 ) {
      display: none;
    }
  }
  .mobile-img {
    display: none;
    @media all and (max-width: $screen-md - 1) {
      display: block;
    }
  }
</style>
